import { render, staticRenderFns } from "./SplashLoader.vue?vue&type=template&id=07adbf63&scoped=true&"
import script from "./SplashLoader.vue?vue&type=script&lang=js&"
export * from "./SplashLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07adbf63",
  null
  
)

export default component.exports